import {
    Address,
    Attributes,
    Maybe,
    SaleEstimate,
    TrackedPropertyRelationship
} from '../graphql.generated';

export type TrackedPropertyTracking = {
    taxonomy: {
        property_relationship?: string | null;
        uprn?: string;
        price?: Maybe<number>;
        outcode?: Maybe<string>;
        location?: Maybe<string>;
    };
};

type TrackingPropertyData = {
    address?: Maybe<Address>;
    attributes?: Maybe<Attributes>;
    saleEstimate?: Maybe<SaleEstimate>;
    uprn: string;
};

export const trackingMap: Record<TrackedPropertyRelationship, string> = {
    [TrackedPropertyRelationship.Homeowner]: 'homeowner',
    [TrackedPropertyRelationship.Landlord]: 'landlord',
    [TrackedPropertyRelationship.Tenant]: 'tenant',
    [TrackedPropertyRelationship.InterestedInBuying]: 'interested_in_buying',
    [TrackedPropertyRelationship.Interested]: 'interested'
};

export const getTrackedPropertyTaxonomyData = (
    { uprn, address, attributes, saleEstimate }: TrackingPropertyData,
    relationship?: Maybe<TrackedPropertyRelationship>
) => {
    return {
        uprn,
        price: saleEstimate?.currentPrice,
        outcode: address?.outcode || undefined,
        location: address?.postcode,
        property_relationship:
            (relationship && trackingMap[relationship]) || 'undefined',
        num_baths: attributes?.bathrooms || null,
        num_beds: attributes?.bedrooms || null,
        num_recepts: attributes?.livingRooms || null,
        property_type: attributes?.propertyType || null
    };
};
